import React, { PureComponent } from 'react';
import Category from './Category';
import { withRouter } from 'react-router-dom';
class Categories extends PureComponent {
  render() {
    return this.props.menu.map((category, index) => {
      return (
        <Category
          query={this.props.query}
          items={category.category_items}
          name={category.category_name}
          key={index}
          click={this.props.click}
          promoCode={this.props.promoCode}
          color={this.props.color}
        />
      );
    });
  }
}

export default withRouter(Categories);



// WEBPACK FOOTER //
// ./src/Categories.js